module.exports = __webpack_public_path__ + "static/img/卡片_未选中状态@2x.fbb0a8de.png";